// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"98ef3492","496":"6c5f2929"}[chunkId] + ".chunk.js";
};